class RecipeNavigationController {
    constructor(recipeCategoriesService) {
        this.recipeCategoriesService = recipeCategoriesService;
    }

    $onInit() {
        this.recipeCategoriesService.getAll();
    }

    $onChanges() {
        if (this.currentCategory) {
            this.openCategory = this.currentCategory.department;
        }
    }

    toggleOpen(category) {
        this.openCategory = this.openCategory === category
            ? null
            : category;
    }
}

const recipeNavigationComponentDefinition = {
    bindings: {
        currentCategory: '<',
    },
    controller: ['RecipeCategoriesService', RecipeNavigationController],
    template: require('./recipe-navigation.component.html').trim(),
};

module.exports = {
    RecipeNavigationController,
    recipeNavigationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/recipe/recipe-navigation.component.js